import { Card, CardBody, Col, Input, Label } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ListWithCheckboxTitle } from "../../../../Constants/Constants";
import { ListCheckboxData, ListWithCheckboxSubTitle } from "../../../../Data/UiKits/Lists";

const ListWithCheckbox = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ListWithCheckboxTitle} span={ListWithCheckboxSubTitle} />
        <CardBody className="dark-list list-checkbox">
          <UL>
            {ListCheckboxData &&
              ListCheckboxData.map((item, index) => (
                <LI key={index}>
                  <Input className={`me-2 checkbox-${item.class} ${index === 0 ? "active" : ""}`} id={item.idFor} type="checkbox" value="" />
                  <Label className={`mb-0 txt-${item.class}`} htmlFor={item.idFor} check>
                    {item.text}
                  </Label>
                </LI>
              ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ListWithCheckbox;
